import styled from 'styled-components';

import { size } from './ButtonContainer';

export default styled.div`
  position: absolute;
  right: ${`calc(-1 * (${size}rem / 2))`};
  top: 0;
  display: grid;
  grid-column-gap: 0.5rem;
  grid-auto-flow: column;
  margin-top: ${`calc(-1 * (${size}rem / 2))`};
`;
